import { AreenaApiClient, hbbTvMode, Mode, ProfileCookies } from './types';

export const applicationType = 'areena';
export const areenaApiClient: AreenaApiClient = 'yle-areena-leanback';

export const isHbbtvLike = (mode: Mode | undefined) => mode === hbbTvMode;

export const isClient = () => {
  return typeof window !== 'undefined';
};

export const isTestRuntime = () => {
  if (isClient()) {
    const env = (typeof window !== 'undefined' && (window as any)).env;
    return env?.APP_ENV === 'test';
  } else {
    return process.env.APP_ENV === 'test';
  }
};

export const isDevRuntime = () => {
  if (isClient()) {
    const env = (typeof window !== 'undefined' && (window as any)).env;
    return env?.APP_ENV === 'dev';
  } else {
    return process.env.APP_ENV === 'dev';
  }
};
export const isStagingRuntime = () => {
  if (isClient()) {
    const env = (typeof window !== 'undefined' && (window as any)).env;
    return env?.APP_ENV === 'staging';
  } else {
    return process.env.APP_ENV === 'staging';
  }
};

export const withQuery = (
  url: string,
  queryParamsObject: { [key: string]: string }
): string => {
  const queryParams = Object.entries(queryParamsObject)
    .map(
      ([key, value]) =>
        `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
    )
    .join('&');

  const separator = url.includes('?') ? '&' : '?';

  const newUrl = `${url}${separator}${queryParams}`;

  return newUrl;
};

export const yleLoginCookieKey: keyof ProfileCookies = isTestRuntime()
  ? 'yletestlogin'
  : 'ylelogin';

export function chunks<T>(arr: T[], n: number): T[][] {
  const chunks: T[][] = [];

  for (let i = 0; i < arr.length; i += n) {
    chunks.push(arr.slice(i, i + n));
  }

  return chunks;
}
